export default __webpack_public_path__ + "static/media/pixels-project-1.1b9ace56.webp";